import React, { useEffect, useState } from "react";
import RoomDetailsBanner from "../components/roomsdetails/RoomDetailsBanner";
import { useLocation } from "react-router-dom";
import RoomInfo from "../components/roomsdetails/RoomInfo";
import RoomService from "../components/roomsdetails/RoomService";
import RoomSlider from "../components/roomsdetails/RoomSlider";
import OthersRooms from "../components/roomsdetails/OthersRooms";
import { useLoader } from "../context/LoaderContext";
import { useRoomContext } from "../context/RoomContext";
import { fetchRoomData } from "../api/RoomsApi";
import { dynamicFailed } from "../hooks/useToast";

interface IRoomData {
  id: number;
}

const RoomDetails = () => {
  const location = useLocation();
  const { roomData, setRoomData } = useRoomContext();
  const { setLoading } = useLoader();
  const [roomDataId, setRoomDataId] = useState<IRoomData>({
    id: 0,
  });

  useEffect(() => {
    if (location.state) {
      setRoomDataId(location.state);
    }
    window.scrollTo(0, 0);
  }, [location.state]);
  useEffect(() => {
    if (roomData.length === 0) {
      Promise.all([fetchRoomData()])
        .then(([RoomData]) => {
          setLoading(false);
          setRoomData(RoomData);
        })
        .catch((error) => {
          setLoading(false);
          dynamicFailed(error.response.data.error.message);
        });
    }
  }, [roomData.length, setLoading, setRoomData]);
  return (
    <>
      <body
        data-rsssl="1"
        className="mphb_room_type-template-default single single-mphb_room_type postid-150 tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default"
      >
        <RoomDetailsBanner id={roomDataId.id} />
        <RoomInfo id={roomDataId.id} />
        <RoomService id={roomDataId.id} />
        <div className="singleroom_other_wrapper">
          <RoomSlider id={roomDataId.id} />
          <OthersRooms id={roomDataId.id} />
        </div>
      </body>
    </>
  );
};

export default RoomDetails;
